export default __webpack_public_path__ + "static/media/Links of Cetriss.170864a4.jpg";